import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreatePaymentTermsTemplate } from "../api/queries";
import { PaymentTermsTemplateForm } from "../ui/PaymentTermsTemplateForm";

export function PaymentTermsTemplateCreatePage() {
  const nav = useNavigate({
    from: "/app/performance/payment-terms-templates/create",
  });
  const createTemplate = useCreatePaymentTermsTemplate();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            {
              label: "ແມ່ແບບເງື່ອນໄຂ",
              to: "/app/performance/payment-terms-templates",
            },
            { label: "ເພີ່ມໃໝ່" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ເພີ່ມແມ່ແບບ</h2>
          <p className="text-muted-foreground">ສ້າງແມ່ແບບເງື່ອນໄຂການຊຳລະເງິນໃໝ່</p>
        </div>

        <div className="rounded-xl border bg-card px-6">
          <PaymentTermsTemplateForm
            onSubmit={async (vals) => {
              try {
                const created = await createTemplate.mutateAsync(vals);
                nav({
                  to: "/app/performance/payment-terms-templates/$id/edit",
                  params: { id: created.id },
                });
              } catch {}
            }}
            onCancel={() =>
              nav({ to: "/app/performance/payment-terms-templates" })
            }
            submitting={createTemplate.isPending}
          />
        </div>
      </Main>
    </>
  );
}
